function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".blockUsera{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-774.299 -680.562)"
}, /*#__PURE__*/React.createElement("path", {
  className: "blockUsera",
  d: "M783.21,681.835a7.638,7.638,0,1,1-7.638,7.638,7.647,7.647,0,0,1,7.638-7.638m0-1.273a8.911,8.911,0,1,0,8.911,8.911,8.911,8.911,0,0,0-8.911-8.911Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(776.491 682.76)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "blockUsera",
  width: 17.714,
  height: 1.273,
  transform: "translate(0 12.526) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-393.223 -4805.713)"
}, /*#__PURE__*/React.createElement("path", {
  className: "blockUsera",
  d: "M1179.993,5500.049h-6.768a1.042,1.042,0,0,1-1.038-1.044,4.423,4.423,0,1,1,8.845,0A1.042,1.042,0,0,1,1179.993,5500.049Zm-3.384-4.556a3.5,3.5,0,0,0-3.478,3.512.1.1,0,0,0,.094.1h6.768a.1.1,0,0,0,.094-.1A3.5,3.5,0,0,0,1176.608,5495.494Zm0-1.231a2.381,2.381,0,1,1,2.364-2.381A2.375,2.375,0,0,1,1176.608,5494.262Zm0-3.817a1.436,1.436,0,1,0,1.419,1.436A1.429,1.429,0,0,0,1176.608,5490.445Z"
})));

var SvgBlockUser = function SvgBlockUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.822,
    height: 17.822,
    viewBox: "0 0 17.822 17.822",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlockUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blockUser.6ebfee09.svg";
export { ForwardRef as ReactComponent };